import React from 'react';

import StudentsOnlineNavbarButton from '../components/live_view/studentsOnlineNavbarButton';

const StudentsOnlineNavbarButtonAppClient = (props) => <StudentsOnlineNavbarButton {...props} />;

export default StudentsOnlineNavbarButtonAppClient;
